import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';

class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'Landing';

    this.state = {

    	}
	}

	render() {
		return
		(
			<div>Test</div>
			)
	}
}


export default connect()(Landing);


// WEBPACK FOOTER //
// ./src/browser/components/recovery/landing.js